module.exports = __webpack_public_path__ + "img/figure8.3efef7d2.png";